export type CompanySettingsAttrsI = Record<string, any>;

export interface CompanyRespWithPermissions extends CompanyResp {
  features: Partial<Features>;
}

export interface CompanyRespWithSettingAttributes extends CompanyResp {
  setting_attributes: CompanySettingsAttrsI;
}

export type CompanyI = CompanyRespWithPermissions & CompanyRespWithSettingAttributes;

export interface CompanyResp {
  uuid: string;
  name: string;
  created_at: string;
  updated_at: string;
  imageUrl: string | null;
  usersCount: number;
  simple_gui: boolean;
}

export interface SurveyFeatures {
  adminsCanViewManagerSurveys: boolean;
  directFeedback: boolean;
  recommendations: boolean;
  showTopicOnCard: boolean;
  spiderGraphGroupByRespondents: boolean;
}

export interface Features {
  survey: Partial<SurveyFeatures>;
  okr: Record<string, never>;
  booking: Record<string, never>;
}

export const defaultFeatures: Partial<Features> = {};
